import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ComponentManagementLayer from "../components/ComponentManagementLayer";
import { Icon } from "@iconify/react";

const InspectionsManagementPage = () => {
  const [viewMode, setViewMode] = useState("table");

  const headerActions = (
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'table' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('table')}
      >
        <Icon icon="ic:baseline-table-view" className="icon text-xl line-height-1" /> Table
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'calendar' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('calendar')}
      >
        <Icon icon="ic:baseline-calendar-month" className="icon text-xl line-height-1" /> Calendar
      </button>
    </div>
  );

  return (
    <>
      <MasterLayout pageTitle="Inspection Management" headerActions={headerActions}>
        <ComponentManagementLayer taskType="inspection" viewMode={viewMode} />
      </MasterLayout>
    </>
  );
};

export default InspectionsManagementPage;
